import React from "react";
import "./modalComponent.css";
import { Modal } from '@mui/material';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import close_x from '../../../images/Fill_1.png'


const ModalComponent = (props) => {
    const {alertMode,isGenericAlert,reverseBtnDirection} = props;
    return (<Modal
        open={props.open}
        aria-labelledby="modal-modal-title"
        // aria-describedby="modal-modal-description" //eslint-disable-next-line
        // aria-sub-describedby="modal-modal-sub-description
        >
        <Box 
        className={"modal_component-box"+(isGenericAlert?" modal_component-genericAlert":"")}
        sx={{
            maxHeight : "80vh",
            overflowY : "auto",
            p :2
        }}
        >
            <Typography id="modal-modal-title" variant="h6" component="h2" className={(isGenericAlert?"generic-alert-title":"")}>
                {props.modalHeader}
                <img src={close_x} alt="close" data-testid="alert-close-icon" className={"close_modal_x"+(isGenericAlert?" generic_close_x":"")} onClick={props.handleClose} />
            </Typography>
            {(alertMode && isGenericAlert)
            ?<div 
                className={`${alertMode && !props.modalHeader?'alertMode-content-compact':''} alertMode-content`}
                data-testid = "generic-alert-content">
                {props.modalContent}
            </div>
            :null}
            {!isGenericAlert
            ?<Typography id="modal-modal-description" className="modal_component-content" textAlign={alertMode?"left":"center"}>
                {props.modalContent} 
            </Typography>
            :null}
            {!alertMode
            ?<Typography id="modal-modal-sub-description" className="modal_component-content" textAlign={"center"}>
                {props.modalSubContent}  {props.subContentValue}
            </Typography>
            :null}
            <div align={alertMode?"right":"center"} 
                className={alertMode?((reverseBtnDirection?"reverse-btns-direction ":"")+"modal_btn_container"):""}>
                {props.firstButton 
                && <button 
                    className={"btn-end"+(alertMode?" alert-close-btn":"")+(isGenericAlert?" generic-alert-btn":"")} 
                    onClick={props.handleFirstButton}
                    data-testid={alertMode?"alert-first-btn":'modal-component-first-btn'}
                >
                    {props.firstButtonContent}
                    </button>
                }
                {/* In alert mode we will have atmost 2 btns */}
                {props.secondButton 
                && <button 
                    className={"btn-normal"+(alertMode?" alert-close-btn":"")+(isGenericAlert?" generic-alert-btn":"")}
                    onClick={props.handleSecondButton}
                    data-testid={alertMode?"alert-second-btn":'modal-component-second-btn'}
                >
                    {props.secondButtonContent}
                </button>}
                {props.thirdButton && !alertMode && <button className="btn-normal" onClick={props.handleThirdButton}>{props.thirdButtonContent}</button>}
            </div>
        </Box>
    </Modal>);
}

export default ModalComponent;